import React from "react";
import ChatButton from "../components/ChatButton";
import { useTranslation } from "react-i18next";

type BookingResponse = {
  id: number;
  email: string | null;
  bookingDetailId: number;
  status: string;
  productId: number;
  qtyAdult: number;
  qtyChild: number;
  qtyRoom: number;
  qtySim: number | null;
  qtyVehicle: number | null;
  ageNumbers: string;
  selectDateNow: boolean;
  duration: number;
  totalPaid: number;
  updatedAt: string;
  priceTotalVehicle: number | null;
  priceTotalAdult: number;
  priceTotalChild: number;
  priceTotalRoom: number | null;
  priceTotalItem: number;
  booking: Booking;
  statusTime: string | null;
};

type Booking = {
  status: string;
  id: number;
  bookNo: number;
  bookTime: string;
  price: number;
  priority1: string | null;
  priority2: string | null;
  priority3: string | null;
  product: Product;
  statusTime: string | null;
};

type Product = {
  id: number;
  cityName: string | null;
  name: string;
  thumbnail: string;
  productType: string;
  categoryId: number | null;
  categories: Category;
  howToUse: string;
  information: string;
  noteContent: string;
  originalPrice: number | null;
  price: number | null;
  categoryName: string | null;
  duration: number;
  discount: Discount;
  showHome: boolean;
};

type Category = {
  id: number;
  name: string;
};

type Discount = {
  value: number;
  discountType: string;
};

type ConsumerOrderDTO = {
  orderDate: string;
  paymentStatus: string | null;
  orderStatus: string;
  subCategory: string;
  userName: string | null;
  phone: string;
  emailCustomer: string;
  emailUser: string | null;
  discountValue: number;
  totalPrice: number;
  address: string;
  nameCustomer: string;
  requirement: string | null;
  statusTime: string | null;
  bookingResponse: BookingResponse;
  request: string | null;
  additional: string | null;
  luggage: string | null;
  pickUpAirport: string | null;
  priorities: string | null;
  ticketType: string | null;
  seat: string | null;
  dataPackage: string | null;
  simValidity: string | null;
  dropOffLocation: string | null;
  // productInfo: ProductInfo;
  products: ProductDetail[] | null;
  bookingConfirm: string | null;
};

// type ProductInfo = {
//   id: number;
//   name: string;
//   thumbnail: string;
//   cityName: string;
//   selectDate: string;
//   priceList: Price[];
//   attributeList: ProductAttributeDTO[];
//   discount: Discount;
//   productType: string;
//   priceSimResponse: string | null;
//   refund: boolean;
//   edit: boolean;
// };

type ProductDetail = {
  id: number;
  email: string | null;
  bookingDetailId: string | null;
  status: string;
  productId: number;
  qtyAdult: number;
  qtyChild: number;
  qtyRoom: number;
  qtySim: number | null;
  qtyVehicle: number | null;
  ageNumbers: string;
  selectDateNow: boolean;
  duration: number;
  totalPaid: number | null;
  updatedAt: string;
  priceTotalVehicle: number;
  priceTotalAdult: number;
  priceTotalChild: number;
  priceTotalRoom: number;
  priceTotalItem: number;
  booking: Booking;
  statusTime: string | null;
  request: string | null;
  additional: string | null;
  luggage: Luggage;
  pickUpAirport: string | null;
  priorities: string | null;
  ticketType: string | null;
  seat: string | null;
  dataPackage: string | null;
  simValidity: string | null;
  dropOffLocation: string | null;
  // productInfo: ProductInfo;
};

type Luggage = {
  id: number;
  type: string;
  value: string;
};

interface BookingStatusProps {
  bookingData: ConsumerOrderDTO;
}

const BookingStatus: React.FC<BookingStatusProps> = ({ bookingData }) => {
  const { t } = useTranslation();
  return (
    <div className="} rounded-[1.25rem] border border-[#DCDCDC] p-[1.25rem] pt-[1.3125rem]">
      <div className="">
        <div className="flex flex-col gap-[0.9375rem]">
          <p className="text-base font-semibold">{bookingData.orderStatus}</p>

          <div className="flex justify-start gap-2">
            <p className="flex w-[10rem] text-[0.875rem] font-semibold">
              {t("Book no")}
            </p>
            <div className="flex items-center justify-between text-[0.875rem]">
              <p className="font-normal text-[#232323]">
                {bookingData.bookingResponse.booking.bookNo}
              </p>
            </div>
          </div>

          <div className="flex justify-start gap-2">
            <p className="flex w-[10rem] text-[0.875rem] font-semibold">
              {t("Book time")}
            </p>
            <div className="flex items-center justify-between">
              <p className="text-[0.875rem] font-normal text-[#232323]">
                {new Intl.DateTimeFormat("ko-KR", {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(
                  new Date(bookingData.bookingResponse.booking.bookTime),
                )}
              </p>
            </div>
          </div>
          {bookingData.orderStatus !== "Confirmed" &&
            bookingData.orderStatus !== "COMPLETED" && <ChatButton />}
        </div>
      </div>
    </div>
  );
};

export default BookingStatus;
